export const usersMenu = [
  {
    path: "/users",
    name: "users",
    label: "Users",
    icon: "users",
    component: () => import("@/views/Users/UsersList.vue"),
    meta: {
      title: "Users List",
      ability: { action: "create", subject: "User" },
    },
  },
];

export const users = [
  {
    path: "/users/:id",
    name: "users.index",
    label: "Users List",
    component: () => import("@/views/Users/UserInfo.vue"),
    meta: {
      title: "User Details",
      ability: { action: "read", subject: "User" },
    },
  },
];
